import { render } from "./HelpMessage.vue?vue&type=template&id=3446eee4&scoped=true"
import script from "./HelpMessage.vue?vue&type=script&lang=ts"
export * from "./HelpMessage.vue?vue&type=script&lang=ts"

import "./HelpMessage.vue?vue&type=style&index=0&id=3446eee4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3446eee4"

export default script